// activityNewUser4
export default {
  routerTitle: '新客户四重奖赏',
  shareTitle: '新客户四重奖赏 奖励层层加码',
  shareDesc: '最高5000+HKD礼包 入金30W达标尊享3200HKD',

  or: '或',
  award: '奖',
  awardAgain: '再奖',
  cashCoupons: '现金券',
  futeStock: '股福特',
  usCurrency: '美元',

  cardOneLabel1: '注册送行情',
  cardOneValue11: '内地客户送30天港股LV2行情',
  cardOneValue12: '完成签署送30天美股LV1行情',
  cardOneLabel2: '开户送 HKD 2256 礼包',
  cardOneValue21: '180天港股LV2串流报价行情',
  cardOneValue22: '180天美股LV1行情',
  cardOneDesc: '注：香港及海外地区港股行情为LV1',

  cardTwoTitle: '首入金2万以上最高赠送 HKD 600 礼包',
  cardTwoTable1: '首入金 HKD 20,000 - 299,999',
  cardTwoTable1Row1: '30天内无出金且交易一次',
  cardTwoTable2: '首次认购投资组合奖励',
  cardTwoTable2Row1: '1000-4999美元',
  cardTwoTable2Row2: '5000-9999美元',
  cardTwoTable2Row3: '10000美元以上',

  cardThreeTitle: '首入金30万以上最高赠送 HKD 3200 礼包',
  cardThreeTable1: '首入金 HKD 30万 以上',
  cardThreeTable1Row1: '30天内无出金且交易一次',
  cardThreeTable2: '交易额达标奖励',
  cardThreeTable2Row11: '30天内无出金',
  cardThreeTable2Row12: '且交易额达到150万',
  cardThreeTable2Row21: '60天内无出金',
  cardThreeTable2Row22: '且交易额达到300万',
  cardThreeTable2Row31: '90天内无出金',
  cardThreeTable2Row32: '且交易额达到450万',
  cardThreeTable3: '首次认购投资组合奖励',
  cardThreeTable3Row1: '投入2万美元且持有30天',
  cardThreeTable3Row2: '投入2万美元且持有60天',
  cardThreeTable3Row3: '投入2万美元且持有90天',
  cardThreeTips: '注：入金30万以上的交易奖励和投资组合奖励只能二选一。',

  cardFourTitle: '首次认购投资组合最高奖励 HKD 1000 礼包',
  cardFourTable1: '首次认购投资组合奖励',
  cardFourTable1Row1: '1000-4999美元',
  cardFourTable1Row2: '5000-9999美元',
  cardFourTable1Row3: '10000美元以上',
  cardFourTable1RowValue: '持有60天以上奖',
  cardFourTips:
    '注：首笔入金30万且投资组合首次认购2万美元，并持有60天的，获得HKD700；将不能与首次认购投资组合10000美元以上，持有60天以上再奖HKD700的奖励重复领取。'
}
